import http from '@/libs/http'

/**
 * 获取店铺信息
 */
export const getShopInfo = () => {
  return http.request({
    url: '/s/shop/get',
    method: 'get'
  })
}

export const getClerkSetting = () => {
  return http.request({
    url: '/s/shop-setting/getClerkSetting',
    method: 'get'
  })
}

export const getUserDomain = ()=>{
  return http.request({
    url: '/s/shop/getDomain',
    params:{
      end: 1
    },
    method: 'get'
  })
}
